import React, { useState } from 'react'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { FormContainer, CreateCollaboWrapper } from './styles'
import { CollaboTypes } from 'src/redux/types/collaboTypes'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'

const CreateCollaboTwo = () => {
  let location = useLocation()
  const [collaboData, setCollaboData] = useState({
    description: '',
  })
  const { description } = collaboData
  const dispatch = useDispatch()
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...collaboData }
    newData[name] = value
    setCollaboData(newData)
    dispatch(action(CollaboTypes.COLLABO_FORM_DATA, newData))
  }
  return (
    <FormContainer>
      <CreateCollaboWrapper>
        <div className="top-content">
          <TargetTitle className="targetTitle">Create Collabo</TargetTitle>
          <div className="amount">
            <h4>What is the description of your group?</h4>
            <QuicksaveInput
              type="text"
              name="description"
              value={description}
              placeholder="Collabo group description"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="top">
          <Link
            to={`/create-collabo-three`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="targets">Continue</ModalButton>
          </Link>
        </div>
      </CreateCollaboWrapper>
    </FormContainer>
  )
}
export { CreateCollaboTwo }
